<template>
    <div class="invoice-container">
        <div class="header">{{ contact && contact.first_name }}</div>
        <nav class="add-navigation flex-wrap flex">
            <div
                    @click="$router.push({ name: 'company-admin-users' })"
                    class="back-link "
            >
                <svg
                        class="icon"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1"
                >
                    <path
                            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                            id="path-1"
                    />
                </svg>
                <p class="white_space">Back to Users</p>
            </div>
            <div class="buttons-wrapper flex-wrap">
                <div
                        @click="$router.push({ name: 'company-admin-users' })"
                        class="secondary-button my-2 my-sm-0"
                >
                    <secondary-button class="button_size">Cancel</secondary-button>
                </div>
                <div class="primary-button my-2 my-sm-0">
                    <primary-button @click.native="editUser">Save User</primary-button>
                </div>
            </div>
        </nav>
        <div class="add-container">
            <span class="container-title">Edit User</span>
            <div class="row p-3" v-if="contact">

                <div class="col-md-6 col-12">
                    <primary-input
                            type="text"
                            name="first name"
                            v-model="contact.first_name"
                            v-validate="'required'"
                            :class="{ input: true, 'is-danger': errors.has('first name') }"
                            placeholder="Enter first name"
                    />
                    <div class="help is-danger" v-if="errors.has('first name')">
                        {{ errors.first("first name") }}
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <primary-input
                            type="text"
                            name="last name"
                            v-model="contact.last_name"
                            v-validate="'required'"
                            :class="{ input: true, 'is-danger': errors.has('last name') }"
                            placeholder="Enter last name"
                    />
                    <div v-if="errors.has('last name')" class="help is-danger">
                        {{ errors.first("last name") }}
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <primary-input
                            type="text"
                            name="user name"
                            v-model="contact.user_name"
                            v-validate="'required'"
                            :class="{ input: true, 'is-danger': errors.has('user name') }"
                            placeholder="Enter username"
                    />
                    <div class="help is-danger" v-if="errors.has('user name')">
                        {{ errors.first("user name") }}
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <primary-input
                            type="password"
                            name="password"
                            :value="contact.passwd"
                            @input="handlePassordChange"
                            v-validate="'required'"
                            ref="password"
                            :class="{ input: true, 'is-danger': errors.has('password') }"
                            placeholder="********"
                    />
                    <div v-if="errors.has('password')" class="help is-danger">
                        {{ errors.first("password") }}
                    </div>
                </div>
                <div class="col-md-6 col-12">

                    <primary-select
                            type="text"
                            name="Status"
                            v-validate="'required'"
                            v-model="contact.is_active"
                            :class="{ input: true, 'is-danger': errors.has('active') }"
                            placeholder="Select status"
                    >
                        <option
                                value="true"
                                :selected="contact.is_active ? 'selected' : ''"
                        >
                            Active
                        </option>
                        <option
                                value="false"
                                :selected="!contact.is_active ? 'selected' : ''"
                        >
                            Inactive
                        </option>
                    </primary-select>
                    <div v-if="errors.has('Status')" class="help is-danger">
                        {{ errors.first("Status") }}
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <primary-input
                            type="password"
                            name="re-enter password"
                            v-validate="'required|confirmed:password'"
                            data-vv-as="password"
                            v-model="checkPassword"
                            :class="{
              input: true,
              'is-danger': errors.has('re-enter password'),
            }"
                            placeholder="********"
                    />
                    <div class="help is-danger" v-if="errors.has('re-enter password')">
                        {{ errors.first("re-enter password") }}
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <primary-input
                            type="text"
                            name="IP List"
                            class="input"
                            v-model="contact.allowed_ip_list"
                            placeholder="Enter IP List"
                    />
                </div>
                <div class="col-md-6 col-12">
                    <primary-input
                            type="text"
                            name="API IP List"
                            class="input"
                            v-model="contact.allowed_api_ip_list"
                            placeholder="Enter API IP List"
                    />
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            EditDropzone: () => import("@/components/EditDropzone"),
        },
        data: () => ({
            contactError: null,
            role: ["Admin", "Normal", "User"],
            contact: null,
            user: {
                contact: {
                    first_name: null,
                    last_name: null,
                    user_name: null,
                    passwd: null,
                    is_active: false,
                    allowed_api_ip_list: null,
                    allowed_ip_list: null,
                },
            },
            file: null,
            checkPassword: null,
            dids: [],
            currentDids: [],
            selectedDids: [],
            removedDids: [],
            changedPassword: null,
        }),
        // watch: {
        //   'currentDids' : function() {
        //     console.log('currentDids', this.currentDids)
        //   }
        // },
        created() {
            this.getUser();
            this.GetDidsList();
        },
        methods: {
            handlePassordChange(value) {
                this.contact.passwd = value;
                this.changedPassword = value;
            },
            removeDid(e) {
                if (this.selectedDids.includes(e)) {
                    this.selectedDids.splice(this.selectedDids.indexOf(e), 1);
                }
                console.log("this.currentDids", this.currentDids);
                if (this.currentDids.includes(e)) {
                    this.removedDids.push(e);
                }
                console.log("this.removedDids", this.removedDids);
            },
            selectDid(e) {
                if (this.removedDids.includes(e)) {
                    this.removedDids.splice(this.removedDids.indexOf(e), 1);
                }
                this.selectedDids.push(e);
                console.log("this.selectedDids", this.selectedDids);
            },
            getUser() {
                this.$store
                    .dispatch("GetUser", {
                        id: this.$route.params.id,
                    })
                    .then((res) => {
                        console.log(res);
                        this.contact = res;
                        //this.selectedDids = res.dids;
                        res.dids.map((i, k) => (this.currentDids[k] = i));

                        this.checkPassword = this.contact.passwd;
                        // this.GetFile();
                    });
            },
            async GetDidsList() {
                let {total} = await this.$store.dispatch("GetAllDids", {});

                const res = await this.$store.dispatch("GetAllDids", {perPage: total});

                this.dids = res.items.map((i) => i.did);
            },
            // GetFile() {
            //   if (!this.contact.logo_file_uuid) { return }

            //   var mockFile = { size: 1024, name: "Userlogo", type: "image/png" };
            //   this.$refs.userEditDropzone.$el.dropzone.emit("addedfile", mockFile);
            //   this.$refs.userEditDropzone.$el.dropzone.emit(
            //     "thumbnail",
            //     mockFile,
            //     `http://88.198.219.62/api_smsc/v1/file/${this.contact.logo_file_uuid}`
            //   );
            //   this.$refs.userEditDropzone.$el.dropzone.emit("complete", mockFile);
            // },
            // fileAdded(file) {
            //   if (file.accepted) {
            //     this.file = file;
            //   }
            // },
            // fileRemoved() {
            //   this.file = null;
            //   this.user.logo_file_uuid = null
            // },
            // uploadFile: async function() {
            //   let data = new FormData();

            //   data.append("file", this.file);
            //   data.append("belongs_to", "user.logo");
            //   data.append("public", true);

            //   return await this.$store.dispatch("UploadFile", data);
            // },
            editUser: async function () {
                const valid = await this.$validator.validate();

                if (valid) {
                    try {
                        if (this.file) {
                            const res = await this.uploadFile();
                            this.user.logo_file_uuid = res.object_uuid;
                        } else {
                            this.user.logo_file_uuid = this.contact.logo_file_uuid;
                        }

                        this.user.first_name = this.contact.first_name;
                        this.user.last_name = this.contact.last_name;
                        this.user.user_name = this.contact.user_name;
                        this.user.is_active = this.contact.is_active;
                        this.user.allowed_api_ip_list = this.contact.allowed_api_ip_list;
                        this.user.allowed_ip_list = this.contact.allowed_ip_list;

                        if (this.changedPassword) {
                            this.user.passwd = this.changedPassword;
                        } else {
                            delete this.user.passwd;
                        }

                        // this.selectedDids.map((i) => {
                        //     const assigRes = this.$store.dispatch("AssignDidToUser", {
                        //         did: i,
                        //         data: {user_id: this.$route.params.id},
                        //     });
                        //     console.log("assign res-> ", assigRes);
                        // });

                        // this.removedDids.map((i) => {
                        //     const resassignRes = this.$store.dispatch("AssignDidToUser", {
                        //         did: i,
                        //         data: {user_id: null},
                        //     });
                        //     console.log("resassignRes res-> ", resassignRes);
                        // });

                        console.log("this.contact", this.contact);

                        await this.$store.dispatch("EditUser", {
                            id: this.$route.params.id,
                            contact: this.user,
                        });

                        this.$snotify.success("User credentials have beed edited.", {
                            timeout: 6000,
                        });

                        this.$router.push({name: "company-admin-users"});
                    } catch (err) {
                        console.log("errrrrr", err);
                        if (err.errors) {
                            this.contactError = err.errors[0].contact
                                ? err.errors[0].contact
                                : null;
                            setTimeout(() => {
                                this.contactError = null;
                            }, 6000);
                        } else if (err.response) {
                            this.$snotify.error(
                                err.response.data.errors
                                    ? err.response.data.errors
                                    : err.response.data.error.message,
                                {timeout: 6000}
                            );
                        } else {
                            this.$snotify.error(err, {timeout: 6000});
                        }
                    }
                }
            },
        },
    };
</script>

<style lang="scss">
    .invoice-container {
        font-family: "Helvetica Neue";
        padding: 0 20px;

        .header {
            //padding-top: 20px;
            font-size: 16px;
            color: #555;
        }

        .add-navigation {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin-bottom: 20px;

            .back-link {
                cursor: pointer;
                display: flex;
                align-items: center;
                fill: #51a3f3;
                color: #51a3f3;
                font-family: "Helvetica Neue";
                font-size: 16px;
                font-weight: 500;
                line-height: 20px;

                p {
                    margin-bottom: 0;
                }
            }

            .buttons-wrapper {
                display: flex;
                align-items: center;
                width: fit-content;

                .primary-button {
                    height: 40px;
                    width: 130px;
                }

                .secondary-button {
                    height: 40px;
                    width: 90px;
                    margin-right: 20px;
                }
            }
        }

        .add-container {
            flex-direction: column;
            align-items: center;
            height: fit-content;
            background-color: #ffffff;
            padding: 15px 0;

            .container-title {
                height: 30px;
                width: 432px;
                color: #000000;
                font-size: 16px;
                font-weight: 500;
                line-height: 30px;
                padding: 15px 0 15px 15px;
            }

            .col-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;
                // margin-left: 15px;
                margin-top: 20px;

                .col {
                    width: 100%;
                    padding-right: 15px;

                    .input {
                        margin-bottom: 20px;
                    }

                    .pimary-input-title {
                        color: #000000;
                        font-family: "Helvetica Neue";
                        font-size: 12px;
                        font-weight: 900;
                        letter-spacing: 0.21px;
                        line-height: 15px;
                        margin-bottom: 5px;
                        text-transform: uppercase;
                    }

                    .dimension,
                    #editdropzone {
                        min-height: 90px;
                        height: 90px;
                        width: 90px;
                        border-radius: 45px;

                        .dz-preview,
                        .dz-processing,
                        .dz-image-preview,
                        .dz-success,
                        .dz-complete,
                        .dz-complete {
                            height: 80px;
                            width: 80px;
                            border-radius: 50px;
                            margin-left: -40px;
                            min-height: 80px;
                            top: -20px;
                        }

                        .dz-image {
                            padding: 5px;

                            img {
                                height: 80px;
                                width: 80px;
                                border-radius: 50px;
                            }
                        }

                        .dz-details {
                            height: 80px;
                            width: 80px;
                            border-radius: 50px;

                            .dz-size {
                                padding-top: 15px;

                                span {
                                    font-size: 14px;
                                }
                            }
                        }

                        a {
                            font-size: 10px;
                            height: 80px;
                            width: 80px;
                            border-radius: 50px;
                            margin-top: 20px;
                            margin-left: 0px;
                        }
                    }

                    .upload-contaioner {
                        background-color: #ffffff;
                        height: 265px;
                        margin-right: 15px;
                        display: flex;

                        .photo {
                            height: 90px;
                            width: 90px;
                            border: 1px solid #5171f3;
                            border-style: dashed;
                            border-radius: 45px;
                            background-color: #ffffff;

                            img {
                                height: 80px;
                                widows: 80px;
                                border-radius: 50px;
                                padding: 5px;
                            }
                        }

                        .upload-content {
                            display: flex;
                            margin: 0 66px 0 15px;

                            span {
                                margin-top: 10px;
                                height: 25px;
                                width: 194px;
                                color: #55616e;
                                font-size: 16px;
                                line-height: 20px;
                            }

                            input[type="file"] {
                                position: absolute;
                                height: 36px;
                                width: 136px;
                                opacity: 0;
                                cursor: pointer;
                                z-index: 1;
                                margin-top: 30px;
                            }

                            // .upload-button {
                            //     height: 36px;
                            //     width: 136px;
                            //     border-radius: 4px;
                            //     background-color: #51A3F3;
                            //     position: absolute;
                            //     margin-top: 30px;
                            // }
                        }
                    }
                }
            }

            .email-input {
                margin-bottom: 20px;
            }

            .password-input {
                margin-bottom: 30px;
            }

            .first {
                margin-bottom: 30px;

                .remember-me {
                    display: flex;
                    align-items: center;

                    input {
                        margin-right: 5px;
                    }
                }
            }
        }
    }
</style>

<style lang="scss" scoped>

    @media (max-width: 339px) {
        .button_size {
            min-width: 130px;
        }

    }

    .row .input {
        margin-bottom: 16px;
    }
</style>

